<template>
  <section>
    <div class="container">
      <div class="handle-box">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addTab" >添加</el-button>
      </div>

      <el-table
        :data="tableData"
        stripe
        @selection-change="checkIds"
        v-loading="loading"
      >
        <el-table-column
          type="selection"
          width="65"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="rid"
          label="ID"
          align="center"
          v-if="false"
        ></el-table-column>
        <el-table-column prop="role_name" label="角色名称" align="center">
        </el-table-column>
        <el-table-column
          prop="role_code"
          label="角色编号"
          align="center"
        ></el-table-column>

        <el-table-column prop="name" label="操作" align="center" width="200">
          <div slot-scope="scope">
            <el-button
              class="ml10"
              type="text"
              icon="el-icon-edit"
              @click="editTable(scope.$index, scope.row)"
              >修改</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red ml10"
              @click="del('Role/Delete', scope.row.rid)"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>

      <!-- 添加修改弹窗 -->
      <el-dialog :title="diaTitle" :visible.sync="diaIsShow" class="diaForm">
        <el-form
          ref="form"
          :model="dataInfo"
          :rules="rules"
          label-width="162px"
        >
          <el-form-item label="角色名称" prop="role_name">
            <el-input
              v-model="dataInfo.role_name"
              class="cms-width flex-100"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色编号" prop="role_code">
            <el-input
              v-model="dataInfo.role_code"
              class="cms-width flex-100"
              :disabled="editType ==='update'"
            ></el-input>
            <span class="gray">填写之后，不可修改</span>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="changeTab('form', editType)"
              >确认</el-button
            >
            <el-button @click="diaIsShow = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 表格底部 -->
      <div class="cms-list-footer">
        <div class="cms-left">
          <el-button
            size="small"
            :disabled="disabled"
            v-show="isadmin"
            @click="deleteBatch('Role/Delete', ids)"
            >批量删除</el-button
          >
        </div>
        <!-- 分页组件 -->
        <cms-pagination :total="total" @change="getPages"></cms-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import va from "@/rules";
import formMixns from "@/mixins/form";
import listMixins from "@/mixins/list";

export default {
  name: "Role",
  mixins: [listMixins, formMixns],
  data() {
    let required = va.required("此项必填");
    let validateCode = va.validateCode("角色名已存在", "Role/IsExist", "");
    return {
      params: {
        //只需要业务参数
        pageNo: "1",
        pageSize: "10"
      },
      rules: {
        // 校验规则
        role_name: [required, validateCode],
        role_code: [required]
      },
      users: [],
      isadmin: false,
      diaIsShow: false,
      editType: "",
      diaTitle: "",
      rowIndex: 0
    };
  },
  mounted() {},
  methods: {
    // add
    addTab() {
      this.diaTitle = "角色添加";
      this.dataInfo = {};
      this.diaIsShow = true;
      this.editType = "add";
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });

      let required = va.required("此项必填");
      let validateCode = va.validateCode("角色名已存在", "Role/IsExist", "");
      this.rules.role_name = [required, validateCode];
    },
    // 编辑
    editTable(index, row) {
      this.diaTitle = "角色修改";
      if ("rid" in row) {
        this.dataInfo = Object.assign({}, row);
      }
      this.editType = "update";
      this.diaIsShow = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.rowIndex = index;

      let required = va.required("此项必填");
      let validateCode = va.validateCode(
        "角色名已存在",
        "Role/IsExist",
        this.dataInfo.rid
      );
      this.rules.devtype = [required, validateCode];
    },
    changeTab(form, type) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (type === "update") {
            // 改变整个表格数据
            Object.assign(this.tableData[this.rowIndex], this.dataInfo);
            this.updateDataInfo("Role/Update", this.dataInfo, "", true);
          } else {
            this.saveDataInfoPromise("Role/Insert",this.dataInfo,"/role/list",'rid')
            .then( res=>{
              this.tableData.unshift(Object.assign({}, res))
            }).catch(err => {
              console.log(err)
            })
          }
          this.diaIsShow = false;
        } else {
          return;
        }
      });
    },
    checkIds(val) {
      let ids = [];
      for (let i in val) {
        ids.push(val[i].rid);
      }
      this.ids = ids.join(",");
      this.disabled = val.length > 0 ? false : true;
      this.checkedList = val;
    },
    del(val1, val2) {
      this.deleteBatch(val1, val2);
    }
  },
  created() {
    //获取信息
    this.initTableData("Role/Paged", this.params);
    this.loading = false;
    this.isadmin = this.$isAdmin();
  }
};
</script>
